/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
export default {
  methods: {
    /**
     * Build Data Structure for modal text input fields
     *
     * @param {object} data Response data object
     * @param {string} billingAddress Comma-separated string containing the address
     *
     * @returns {array}
     */
    buildModalProps (data, billingAddress) {
      return [
        {
          value: 'Business details',
          fields: [
            {
              fieldName: 'registeredName',
              type: 'text',
              value: data.billing_details.registered_name,
              placeholder: 'Registered name'
            },
            {
              fieldName: 'registrationNumber',
              type: 'text',
              value: data.billing_details.registration_number,
              placeholder: 'Registration number'
            },
            {
              fieldName: 'vatNumber',
              type: 'text',
              value: data.billing_details.vat_number,
              placeholder: 'VAT number'
            },
            {
              fieldName: 'billingAddress',
              type: 'address',
              value: billingAddress,
              placeholder: 'Billing address'
            }
          ]
        },
        {
          value: 'Billing contact person',
          fields: [
            {
              fieldName: 'contactPersonName',
              type: 'text',
              value: data.contact_person.name,
              placeholder: 'Contact person full name'
            },
            {
              fieldName: 'contactPersonEmail',
              type: 'text',
              value: data.contact_person.email,
              placeholder: 'Contact person email address'
            }
          ]
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/billing-details-modal-data.js